import validatableWithSyncInitialize from './validatableWithSyncInitialize';
import {valueValidatableClearance} from './valueValidatableInitialize';

const datePickerInitialize = (RMI, contextId, compId) => validatableWithSyncInitialize(RMI, contextId, compId);
const datePickerClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {datePickerInitialize, datePickerClearance};
